import { render, staticRenderFns } from "./TrimStep.vue?vue&type=template&id=2dd7d06c"
import script from "./TrimStep.vue?vue&type=script&lang=ts"
export * from "./TrimStep.vue?vue&type=script&lang=ts"
import style0 from "./TrimStep.vue?vue&type=style&index=0&id=2dd7d06c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports